var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import ouiBase from '@goldwasserexchange/oui';
import { makeName } from '../../../../../makeName';
import { professionOptionalLastProfession, mayHavePreviousJobProfessionList, } from '../list';
import * as TYPE from '../../TYPE';
import { EcplProf } from '../../../../../types';
export * as show from './show';
var hadProfessionPath = 'HadProfession';
var idEcplProfPath = 'ID_ECPL_PROF';
export function makeIdEcplProfLogic(props) {
    var is = props.is, alternatives = props.alternatives, options = props.options, _a = props.parentNameAdditionalPaths, parentNameAdditionalPaths = _a === void 0 ? [] : _a;
    return {
        name: makeName.apply(void 0, __spreadArray(__spreadArray(['<parentName>'], __read(parentNameAdditionalPaths), false), [idEcplProfPath], false)),
        is: is,
        options: options,
        alternatives: alternatives,
    };
}
export function makeIdEcplProfOptionalLastProfession(logic) {
    var _a = logic.options, options = _a === void 0 ? {} : _a, alternatives = logic.alternatives;
    return makeIdEcplProfLogic({
        is: professionOptionalLastProfession,
        options: __assign(__assign({}, options), { matcher: ouiBase.utils.match.arrayMatcherNames.some }),
        alternatives: alternatives,
    });
}
export function makeIdEcplProfShouldHaveProfessionLogic(props) {
    var _a = props.visible, visible = _a === void 0 ? {
        result: 'visible',
    } : _a, _b = props.invisible, invisible = _b === void 0 ? {
        result: 'invisible',
    } : _b;
    return TYPE.logic.makeTAddIsTypePhysicLogic({
        alternatives: {
            truthy: makeIdEcplProfLogic({
                is: EcplProf.STUDENT,
                options: { isNegative: true },
                alternatives: {
                    truthy: makeIdEcplProfOptionalLastProfession({
                        alternatives: {
                            truthy: {
                                name: "<parentName>.".concat(hadProfessionPath),
                                is: true,
                                alternatives: {
                                    truthy: visible,
                                    falsy: invisible,
                                },
                            },
                            falsy: visible,
                        },
                    }),
                    falsy: invisible,
                },
            }),
            falsy: invisible,
        },
    });
}
export function makeIdEcplProfMayHavePreviousJobProfession(logic) {
    var _a = logic.options, options = _a === void 0 ? {} : _a, alternatives = logic.alternatives;
    return ({
        name: "<parentName>.".concat(idEcplProfPath),
        is: mayHavePreviousJobProfessionList,
        options: __assign(__assign({}, options), { matcher: ouiBase.utils.match.arrayMatcherNames.some }),
        alternatives: alternatives,
    });
}
export function makeIdEcplProfMayHaveProfessionHasLastProfessionFilterLogic(props) {
    var _a = props.visible, visible = _a === void 0 ? {
        result: 'visible',
    } : _a, _b = props.invisible, invisible = _b === void 0 ? {
        result: 'invisible',
    } : _b;
    return TYPE.logic.makeTAddIsTypePhysicLogic({
        alternatives: {
            truthy: makeIdEcplProfMayHavePreviousJobProfession({
                alternatives: {
                    truthy: makeIdEcplProfOptionalLastProfession({
                        alternatives: {
                            truthy: {
                                name: "<parentName>.".concat(hadProfessionPath),
                                is: true,
                                alternatives: {
                                    truthy: visible,
                                    falsy: invisible,
                                },
                            },
                            falsy: visible,
                        },
                    }),
                    falsy: invisible,
                },
            }),
            falsy: invisible,
        },
    });
}
